import { createAction, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateMyEnterpriseStripeCustomerProps, ReduxEnterpriseStripeBillingAddEditState } from '../types';
import { ReduxSliceState } from '../../../shared/types';
import { withPayloadType } from '../../../shared/utils';
import { ReduxRootState } from '../../../shared/redux/store';
import { Enterprise } from '../../../api/types';

const initialState: ReduxEnterpriseStripeBillingAddEditState = {
    state: 'BUSY',
    enterprise: undefined,
};

// Self-service only - see EnterpriseStripeBillingController; the caller's own Enterprise is
// always resolved server-side, never accepted from the client.
export const loadMyEnterpriseStripeBilling = createAction('enterprisestripebilling/add-edit/loadMyEnterpriseStripeBilling');
export const createMyEnterpriseStripeCustomer = createAction('enterprisestripebilling/add-edit/createMyEnterpriseStripeCustomer', withPayloadType<CreateMyEnterpriseStripeCustomerProps>());

const enterpriseStripeBillingAddEditSlice = createSlice({
    name: 'enterprisestripebilling/add-edit',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.state = action.payload;
        },
        setEnterprise: (state, action: PayloadAction<Enterprise | undefined>) => {
            state.enterprise = action.payload;
        },
    }
});

export default enterpriseStripeBillingAddEditSlice;

const selectSelf = (state: ReduxRootState) => state.enterpriseStripeBillingAddEdit;

export const selectEnterpriseStripeBillingAddEditState = createSelector(selectSelf, self => self.state);
export const selectEnterpriseStripeBillingAddEditIsBusy = createSelector(selectEnterpriseStripeBillingAddEditState, state => state === 'BUSY');
export const selectEnterpriseStripeBilling = createSelector(selectSelf, self => self.enterprise);
export const selectEnterpriseStripeBillingCustomerId = createSelector(selectSelf, self => self.enterprise?.customerId);
